module.exports = {
      id: "ic-hollow-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-hollow-usage",
      toString: function () {
        return this.url;
      }
    }